export default {
  // 500~999 (tooltip, dropdown, datePicker)
  dropDownContent: 500,
  // 1000 (modal, reactstrap의 modal zIndex 기준)
  modal: 1000,
}
